import React from "react";
import { Icon } from "../Icon/Icon";

// Internal links on React should use <Link to=""></Link> instead of <a href=""></a> tag
export const LinkText = ({
  type,
  customClasses,
  preLinkText,
  linkUrl,
  modal,
  linkText,
  withIcon,
  nameIcon,
  ...props
}) => {
  function renderContent() {
    const content = (
      <>
        {linkText}
        {withIcon === "yes" ? (
          <span className="icon-link">
            <Icon setviewBox="yes" name={nameIcon} />
          </span>
        ) : (
          ""
        )}
      </>
    );

    return content;
  }
  return (
    <h5 className={[type, customClasses].join(" ")}>
      {type === "info-link" ? preLinkText : ""}{" "}
      {modal === "yes" ? (
        <a href={linkUrl} data-modal="trasparenza" {...props}>
          {renderContent()}
        </a>
      ) : (
        <a href={linkUrl} {...props}>
          {renderContent()}
        </a>
      )}
    </h5>
  );
};
